import { render, staticRenderFns } from "./newPay.vue?vue&type=template&id=59cb4747&scoped=true"
import script from "./newPay.vue?vue&type=script&lang=js"
export * from "./newPay.vue?vue&type=script&lang=js"
import style0 from "./newPay.vue?vue&type=style&index=0&id=59cb4747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cb4747",
  null
  
)

export default component.exports